// extracted by mini-css-extract-plugin
export default {"infoLabel":"InfoLabel_infoLabel__JK0Wl","bold":"InfoLabel_bold__4ctYV"};